<div class="spin-wheel-outer">


<form *ngIf="isRegister" [formGroup]="registrationForm">
    <div class="banner">
        <img src="assets/images/spin-the-wheel.png">
    </div>
    <div class="spin-wheel-form-block">
        <div class="spin-wheel-form-label">Name*</div>
        <input class="spin-wheel-field-style" formControlName="fullName" required name="participantName" type="text" placeholder="Enter your Name">
        <div class="error" *ngIf="submitted && registrationForm.get('fullName').invalid">Please enter name</div>
    </div>
    <div class="spin-wheel-form-block">
        <div class="spin-wheel-form-label">District*</div>
        <select class="spin-wheel-field-style" formControlName="customerLocation">
            <option value="">--Please choose an option--</option>
            <option value="thiruvananthapuram">Thiruvananthapuram</option>
            <option value="kollam">Kollam</option>
            <option value="pathanamthitta">Pathanamthitta</option>
            <option value="alappuzha">Alappuzha</option>
            <option value="kottayam">Kottayam</option>
            <option value="idukki">Idukki</option>
            <option value="ernakulam">Ernakulam</option>
            <option value="thrissur">Thrissur</option>
            <option value="palakkad">Palakkad</option>
            <option value="malappuram">Malappuram</option>
            <option value="wayanad">Wayanad</option>
            <option value="kozhikode">Kozhikode</option>
            <option value=" Kannur">Kannur</option>
            <option value="kasaragod">Kasaragod</option>
        </select>
        <div class="error" *ngIf="submitted && registrationForm.get('customerLocation').invalid">Please select district</div>
    </div>
    <div class="spin-wheel-form-block">
        <div class="spin-wheel-form-label">E-mail Id*</div>
        <input class="spin-wheel-field-style"  formControlName="emailId" required type="email" placeholder="Enter your E-mail Id">
        <div class="error" *ngIf="submitted && registrationForm.get('emailId').invalid">Please enter valid email</div>
    </div>

    <div class="spin-wheel-form-block">
        <div class="spin-wheel-form-label">Contact Number*</div>
        <input class="spin-wheel-field-style" formControlName="mobileNumber" required name="mobile" type="number" placeholder="Enter your Contact Number">
        <div class="error" *ngIf="submitted && registrationForm.get('mobileNumber').invalid">Please enter mobile</div>
    </div>
    <button class="cmp-nissan-onam__spin-btn " (click)="register()">
        <span>{{btText}}</span>
    </button>

    <div class="already-reg" *ngIf="isRegistered">Mobile already registerd</div>
</form>

<div *ngIf="isWheel">
    <div style="text-align: center; position: relative;">
        <div class="logo-nissan">
            <div class="logo-nissan-inner">
                <img class="no-jump-img" src="assets/images/nissan-spin-wheel.png">
            </div>
        </div>
            <ngx-wheel class="ngx-wheel" #wheel width="340" height="340" spinDuration="8" [items]="items" [innerRadius]="20" [spinAmount]="10" [textOrientation]="textOrientation"
            [textAlignment]="textAlignment" pointerStrokeColor="#000" pointerFillColor="#000" [idToLandOn]="idToLandOn" (onSpinStart)="before()"
            (onSpinComplete)="after()"></ngx-wheel>
    </div>

        <button class="cmp-nissan-onam__spin-btn " (click)="spin(idToLandOn)">SPIN</button>
</div>

<div *ngIf="isSuccess" style="width: 100%">
    <div style="width: 100%">
            <div class="logo-nissan-outer" style="width: 100%">
            <div class="logo-nissan" style="background: none; position: inherit; left: inherit; top: inherit; margin: 0 auto; ">
                    <div class="logo-nissan-inner">
                        <img class="no-jump-img" src="assets/images/tick.png">
                    </div>
                </div>
            </div>
        <div class="sucess-message">Successfully participated</div>
        <div class="sucess-message-prize">You won {{wonPrize}}</div>

    </div>

</div>
</div>